export default {
  'services.slide.title': 'Nos partenaires',
  'services.offer.title': 'Services par catégories',
};
